import { render, staticRenderFns } from "./CoinAgaList.vue?vue&type=template&id=628363ae&scoped=true&"
import script from "./CoinAgaList.vue?vue&type=script&lang=js&"
export * from "./CoinAgaList.vue?vue&type=script&lang=js&"
import style0 from "./CoinAgaList.vue?vue&type=style&index=0&id=628363ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628363ae",
  null
  
)

export default component.exports